import React, { FC, memo } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import Item from './InstitutionRankingsItem'
import { IRankingsProps } from '../types'
import { dictionary } from '../constants'

const InstitutionRates: FC<IRankingsProps> = ({ type, rankings }) => {
  return (
    <>
      <Heading
        h2={`${dictionary.title[type]} в рейтингах`}
        spacing='large'
        firstLetterUppercase
      />

      {rankings.map((data) => {
        return <Item key={data.id} data={data} />
      })}
    </>
  )
}

export default memo(InstitutionRates)
